// The semi-colon before the function invocation is a safety 
// net against concatenated scripts and/or other plugins 
// that are not closed properly.
; (function ($, window, document, undefined) {

    // undefined is used here as the undefined global 
    // variable in ECMAScript 3 and is mutable (i.e. it can 
    // be changed by someone else). undefined isn't really 
    // being passed in so we can ensure that its value is 
    // truly undefined. In ES5, undefined can no longer be 
    // modified.

    // window and document are passed through as local 
    // variables rather than as globals, because this (slightly) 
    // quickens the resolution process and can be more 
    // efficiently minified (especially when both are 
    // regularly referenced in your plugin).

    // Create the defaults once
    var pluginName = 'roofcalcMap';
    var $base = null;

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.$element = $(element);

        var defaults = {
            zoom: 4,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: 'terrain',
            onElevationChanged: function (elevation) { },
            onDistanceCalculated: function (kilometers) { },
            onWindSpeedChanged: function (data) { },
            onWindSpeedDataLayerLoaded: function () { },
            onLoaded: function () { },
            address: 'Sweden',
            markerSrc: '',
            draggableCursor: 'crosshair',
            draggingCursor: 'auto',
            country: 'default',
            dataBaseUrl: window.location.protocol + '//' + window.location.hostname + '/App_Data/Maps/',
            loadingLabel: 'Loading...'
        };

        this.options = $.extend({}, defaults, options);

        this.siteMarker = null;

        this._defaults = defaults;
        this._name = pluginName;
        this._map = new google.maps.Map(this.element, this.options);
        this._elevationService = new google.maps.ElevationService();
        this._geocoder = new google.maps.Geocoder();
        this._infoWindow = new google.maps.InfoWindow({ content: '' });

        $base = this;

        this.init();
    }

    Plugin.prototype.init = function () {

        $base.$element.attr('type', this._name);

        // Add loader
        $('<div id="loader">' + $base.options.loadingLabel + '</div>').appendTo($base.$element);

        google.maps.event.addListener($base._map, 'click', $base.setDistance);
        google.maps.event.addListener($base._map.data, 'click', $base.setDistance);

        google.maps.event.addListener($base._map.data, 'addfeature', function (event) {
            // Set the proper bounds for each polygon
            var bounds = new google.maps.LatLngBounds();
            event.feature.getGeometry().forEachLatLng(function (latLng) { bounds.extend(latLng); });
            event.feature.setProperty('bounds', bounds);
        });

        google.maps.event.addListenerOnce(this._map, 'idle', function () {
            $base.getWindmapColors(function (data) {
                $base._map.data.setStyle(function (feature) {
                    var wind = feature.getProperty('Takavvatning');
                    var color = 'gray';

                    for (var i = 0; i < data.length; i++) {
                        if (data[i].windspeedmin <= wind && data[i].windspeedmax >= wind) {
                            color = data[i].color;
                        }
                    }

                    return {
                        cursor: 'crosshair',
                        draggable: false,
                        fillColor: color,
                        fillOpacity: 0.6,
                        strokeColor: 'gray',
                        strokeOpacity: 0.7,
                        strokeWeight: 1
                    };
                });

                $base.addWindSpeedDataLayer();
            });
        });

        $($base.$element).siblings('#toggle-datalayer').on('click', function (e) {
            e.preventDefault();
            $base.toggleWindSpeedDataLayer();
        });
    };

    Plugin.prototype.getWindmapColors = function (callback) {
        $.getJSON($base.options.dataBaseUrl + 'windmap-colors.json?v=' + (new Date()).getTime(), function (json) {
            var data = json[0].values;
            $.each(json, function () {
                if (this.country === $base.options.country) {
                    data = this.values;
                }
            });

            callback(data);
        });
    };

    Plugin.prototype.setDistance = function (event) {

        var startPoint = $base.siteMarker.getPosition();
        var endPoint = event.latLng;

        var meters = google.maps.geometry.spherical.computeDistanceBetween(startPoint, endPoint);
        $base.options.onDistanceCalculated(meters / 1000);
        console.log('Distance to marker: ' + (meters / 1000) + 'km');
    };

    Plugin.prototype.isInPolygon = function (latLng, polygon) {

        // Check this: http://www.eecs.umich.edu/courses/eecs380/HANDOUTS/PROJ2/InsidePoly.html

        var intersects = [];
        var tolerance = 0.00000001;
        var polygonPaths = polygon.getPath().i;

        var point = { X: parseFloat(latLng.lat()), Y: parseFloat(latLng.lng()) };
        var a = { X: parseFloat(polygonPaths[polygonPaths.length - 1].lat()), Y: parseFloat(polygonPaths[polygonPaths.length - 1].lng()) };
        for (var i = 0; i < polygonPaths.length; i++) {
            var b = { X: parseFloat(polygonPaths[i].lat()), Y: parseFloat(polygonPaths[i].lng()) };

            if (Math.abs(b.X - point.X) < tolerance && Math.abs(b.Y - point.Y) < tolerance) {
                return true;
            }

            if (Math.abs(b.X - a.X) < tolerance && Math.abs(point.X - a.X) < tolerance && (point.X > Math.min(a.Y, b.Y) || Math.abs(point.X - Math.min(Math.min(a.Y, b.Y)) < tolerance)) && (point.Y < Math.max(a.Y, b.Y) || Math.abs(point.Y - Math.max(a.Y, b.Y) < tolerance))) {
                return true;
            }

            if (Math.abs(b.Y - a.Y) < tolerance && Math.abs(point.Y - a.Y) < tolerance && (point.X > Math.min(a.X, b.X) || Math.abs(point.X - Math.min(a.X, b.X)) < tolerance) && (point.X < Math.max(a.X, b.X) || Math.abs(point.X - Math.max(a.X, b.X)) < tolerance)) {
                return true;
            }

            if ((b.Y < point.Y && (a.Y > point.Y || Math.abs(a.Y - point.Y) < tolerance)) || (a.Y < point.Y && (b.Y > point.Y || Math.abs(b.Y - point.Y) < tolerance))) {
                var px = (b.X + 1.0 * (point.Y - b.Y) / (a.Y - b.Y) * (a.X - b.X));
                intersects.push(px);
            }

            // For integers
            //if (b.X === point.X && b.Y === point.Y) {
            //    return true;
            //}

            //if (b.X === a.X && point.X === a.X && point.X >= Math.min(a.Y, b.Y) && point.Y <= Math.max(a.Y, b.Y)) {
            //    return true;
            //}

            //if (b.Y === a.Y && point.Y === a.Y && point.X >= Math.min(a.X, b.X) && point.X <= Math.max(a.X, b.X)) {
            //    return true;
            //}

            //if ((b.Y < point.Y && a.Y >= point.Y) || (a.Y < point.Y && b.Y >= point.Y)) {
            //    var px = (b.X + 1.0 * (point.Y - b.Y) / (a.Y - b.Y) * (a.X - b.X));
            //    intersects.push(px);
            //}

            a = b;
        }

        intersects.sort();
        return intersects.indexOf(point.X) % 2 === 0 || $.grep(intersects, function (x) { return x < point.X; }).length % 2 === 1;
    };

    Plugin.prototype.getWindSpeed = function (latLng) {

        if (!latLng)
            return null;

        console.log('Determine rainfall for location: ' + latLng.lat() + ', ' + latLng.lng());

        var matchedWind = null;
        var matchingFeatures = [];
        $base._map.data.forEach(function (feature) {

            var geometry = feature.getGeometry();
            for (var i = 0; i < geometry.getLength(); i++) {
                var items = geometry.getAt(i);

                var paths = [];
                if (items.getType() === 'LinearRing') {
                    paths = items.getArray();
                }
                else if (items.getType() === 'Polygon') {

                    for (var j = 0; j < items.getLength(); j++) {
                        paths.push(items.getAt(j).getArray());
                    }

                } else {
                    console.log(items.getType());
                    return true;
                }

                var polygon = new google.maps.Polygon({
                    paths: paths
                });

                if (google.maps.geometry.poly.containsLocation(latLng, polygon)) {
                    var area = parseFloat(google.maps.geometry.spherical.computeArea(polygon.getPath()));
                    var wind = parseFloat(feature.getProperty('Takavvatning'));
                    var regionGroup = feature.getProperty('RegionGroup');

                    // Sometimes we get multiple features with the same wind speed, only add the largest feature to the collection.
                    var existingFeature = null;
                    for (var j = matchingFeatures.length - 1; j >= 0; j--) {

                        if (matchingFeatures[j].wind === wind) {

                            existingFeature = matchingFeatures[j];

                            // Existing feature is smaller, remove it and add the current feature
                            if (existingFeature.area <= area) {
                                //console.log('Removed ' + existingFeature.wind + ' (' + existingFeature.area + ')');
                                matchingFeatures.splice(j, 1);
                                existingFeature = null;
                            }
                        }
                    }

                    if (existingFeature === null) {
                        matchingFeatures.push({ area: area, wind: wind, regionGroup: regionGroup });
                        console.log('Matched wind (pending more matches): ' + wind + ' m/s (' + area + ' m2)');
                    } else {
                        console.log('Skipping already existing wind (with larger area): ' + wind + ' m/s (' + area + ' m2)');
                    }
                }
            }
        });

        var smallest = null;
        if (matchingFeatures.length > 0) {
            for (var i = 0; i < matchingFeatures.length; i++) {
                //console.log('Area: ' + matchingFeatures[i].area + ', Wind: ' + matchingFeatures[i].wind);
                if (smallest == null || smallest.area > matchingFeatures[i].area) {
                    smallest = matchingFeatures[i];
                }
            }
        }

        if (smallest != null) {
            console.log('Actual matched wind: ' + smallest.wind);
        }
        else {
            console.log('No wind data matched for position!');
        }

        return smallest;
    };

    Plugin.prototype.markerMoved = function (event) {

        var setElevation = function (event) {
            var locations = [];
            locations.push(event.latLng);
            $base._elevationService.getElevationForLocations({ 'locations': locations }, function (results, status) {
                if (status !== google.maps.ElevationStatus.OK) {
                    $base.$element.displayMessageBox("Elevation service failed due to: " + status, "Error");
                }

                if (results.length === 0) {
                    $base.$element.displayMessageBox("Could not fetch elevation for location!", "Warning");
                }

                var elevation = parseInt(results[0].elevation);
                $base.options.onElevationChanged(elevation);
                console.log('Elevation: ' + elevation + 'm');
                return elevation;
            });
        };

        var setWindSpeed = function (event) {

            var data = $base.getWindSpeed(event.latLng);
            if (data != null) {
                $base.options.onWindSpeedChanged(data);
            }
        };

        setWindSpeed(event);
        setElevation(event);
    };

    Plugin.prototype.setAddress = function (address) {
        $base._geocoder.geocode({ 'address': address }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                $base._map.setCenter(results[0].geometry.location);

                if ($base.siteMarker)
                    $base.siteMarker.setMap(null);

                $base.siteMarker = new google.maps.Marker({
                    map: $base._map,
                    position: results[0].geometry.location,
                    draggable: true,
                    animation: google.maps.Animation.DROP,
                    icon: $base.options.markerSrc,
                    cursor: 'auto'
                });

                $base.markerMoved({ latLng: $base.siteMarker.getPosition() });

                google.maps.event.addListener($base.siteMarker, 'dragend', $base.markerMoved);

            } else {
                $base.$element.displayMessageBox("Geocode was not successful for the following reason: " + status + " (" + search + ")", "Error");
            }
        });
    };

    Plugin.prototype.addWindSpeedDataLayer = function () {

        console.log('Fetch wind data for ' + $base.options.country + '...');
        $.getJSON($base.options.dataBaseUrl + $base.options.country + '.json?v=' + (new Date()).getTime(), function (json) {
            try {
                $base._map.data.addGeoJson(json);
                $base.options.onWindSpeedDataLayerLoaded();

                // Create legend
                $base.getWindmapColors(function (data) {
                    var $legend = $('<div id="map_legend"></div>');

                    var winds = [];
                    $base._map.data.forEach(function (feature) {
                        var wind = feature.getProperty('Takavvatning');
                        if (!winds.includes(wind)) {
                            winds.push(wind);
                        }
                    });
                    winds.sort();

                    for (var i = 0; i < winds.length; i++) {
                        var color = 'gray';
                        for (var j = 0; j < data.length; j++) {
                            if (data[j].windspeedmin <= winds[i] && data[j].windspeedmax >= winds[i]) {
                                color = data[j].color;
                            }
                        }

                        $('<div class="legend-wind"><span style="background-color: ' + color + ';"></span>' + winds[i] + 'mm</div>').appendTo($legend);
                    }

                    $legend.insertAfter($base.$element);
                });
            } catch (e) {
                // Silence
                console.log(e);
            }
        }).always(function () {
            $base.options.onLoaded();
            $('#loader', $base.$element).remove();
        });

        return this;
    };

    Plugin.prototype.toggleWindSpeedDataLayer = function () {

        if (!$base._windData) {
            $base._windData = $base._map.data;
        }

        if (!$base._windData || $base._windData === null) {
            return this;
        }

        if ($base._windData.map === null) {
            $base._windData.setMap($base._map);
            $('#map_legend').show();
        } else {
            $base._windData.setMap(null);
            $('#map_legend').hide();
        }

        return this;
    };

    // A really lightweight plugin wrapper around the constructor, 
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new Plugin(this, options));
            }
        });
    };
})(jQuery, window, document);